const modalNames = {
  ERROR_MODAL: "ERROR_MODAL",
  UNSHARE_INVOICE_MODAL: "UNSHARE_INVOICE_MODAL",
  MODIFY_INVOICE_MODAL: "MODIFY_INVOICE_MODAL",
  VOID_MODAL: "VOID_MODAL",
  PRE_PAYMENT_MODAL: "PRE_PAYMENT_MODAL",
  INVOICE_PROCESSING_MODAL: "INVOICE_PROCESSING_MODAL",
  CREATE_INVOICE_MODAL: "CREATE_INVOICE_MODAL"
};

export default modalNames;
